import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

//import { useDispatch } from 'react-redux';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

//import { addPostcodeCsv } from '../../../store/documentService';
import DDLOptionPicker from '../../ui/pickers/DDLOptionPicker';
import Uploader from '../Uploader';
import UploaderResults from '../UploaderResults';

import { initialErrorState, validate } from './validateNdppUploader';

import modal from '../../../commonStyles/modal.module.css';

const maxFileSize = 25;
const fileTypes = '.csv';
const acceptedFileTypes = ['text/csv'];

const NdppUploaderModal = ({ contracts, onClose, onCancel, isOpen }) => {
    // const dispatch = useDispatch();
    const [errors, setErrors] = useState(initialErrorState);
    const [failures, setFailures] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [fileName, setFileName] = useState('');
    const [chosenContract, setChosenContract] = useState({});
    const [isDisabled, setIsDisabled] = useState(true);
    const clearError = (key) => {
        setErrors((prev) => ({ ...prev, [key]: { ...errors[key], error: false } }));
    };

    useEffect(() => {
        const isValid = validate(chosenContract, errors);
        setIsDisabled(!isValid);
    }, [chosenContract]);

    const onUpload = (payload, successMsg) => {
        console.debug(chosenContract?.id, payload, successMsg);
        //dispatch(addPostcodeCsv(chosenContract?.id, payload, successMsg));
    };
    const onLoaded = (uploadErrors, csvFileName) => {
        setChosenContract({});
        uploadErrors && setFailures(uploadErrors);
        csvFileName && setFileName(csvFileName.split('.')[0]);
        setIsLoaded(true);
    };

    const onResultsClose = () => {
        setErrors([]);
        setFailures([]);
        setIsLoaded(false);
        onClose();
    };

    return (
        <Dialog onClose={onClose} open={isOpen} fullWidth={true}>
            <div className={modal.modalHeader}>
                <DialogTitle>NDPP Uploader</DialogTitle>
            </div>
            <DialogContent>
                {!isLoaded ? (
                    <>
                        <div>
                            <DDLOptionPicker
                                label="Contract"
                                id="contractId"
                                mandatory={true}
                                menuItems={contracts || []}
                                chosenName={chosenContract?.name || ''}
                                chosenId={chosenContract?.id || ''}
                                onChange={(chosenId) => {
                                    clearError('contractId');
                                    const contract = contracts.find((el) => el.id === chosenId);
                                    setChosenContract(contract);
                                }}></DDLOptionPicker>
                        </div>
                        <Uploader
                            uploadData={[{ key: 'contractId', value: chosenContract?.id }]}
                            acceptedFileTypes={acceptedFileTypes}
                            fileTypes={fileTypes}
                            maxFileSize={maxFileSize}
                            onUpload={onUpload}
                            onClose={onLoaded}
                            onCancel={onCancel}
                            isDisabled={isDisabled}
                        />
                    </>
                ) : (
                    <UploaderResults
                        fileName={fileName}
                        failures={failures}
                        onClose={onResultsClose}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default NdppUploaderModal;

NdppUploaderModal.propTypes = {
    contracts: PropTypes.arrayOf(PropTypes.object),
    onClose: PropTypes.func,
    onCancel: PropTypes.func,
    isOpen: PropTypes.bool
};
